import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CrewMember } from 'app/features/flights/flight-detail/model/crew-member';
import { DynamicDialogConfig, } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { RequestState } from '@shared/models/request-state';
import { AppService } from 'app/app.service';

@Component({
  selector: 'app-crew-contact-info',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './crew-contact-info.component.html',
  styleUrl: './crew-contact-info.component.scss'
})
export class CrewContactInfoComponent implements OnInit {

  crewMemberDetails$?: Observable<RequestState<CrewMember>>;

  phoneIconLight = '/assets/icons/com/phoneIconLight.svg';
  phoneIconDark = '/assets/icons/com/phoneIconDark.svg';
  telephoneIconLight = '/assets/icons/com/telephoneIconLight.svg';
  telephoneIconDark = '/assets/icons/com/telephoneIconDark.svg';
  smsIconLight = '/assets/icons/com/smsIconLight.svg';
  smsIconDark = '/assets/icons/com/smsIconDark.svg';
  emailIconLight = '/assets/icons/com/emailIconLight.svg';
  emailIconDark = '/assets/icons/com/emailIconDark.svg';

  // Disabled or Offical Use Only Icons
  emailIconNone = '/assets/icons/com/emailIconNone.svg';
  phoneIconNone = '/assets/icons/com/phoneIconNone.svg';
  smsIconNone = '/assets/icons/com/smsIconNone.svg';
  telephoneIconNone = '/assets/icons/com/telephoneIconNone.svg';



  constructor(
    private config: DynamicDialogConfig,
    public appService: AppService,
  ) { }

  ngOnInit(): void {
    const crewData = this.config.data;
    if (crewData) {
      this.crewMemberDetails$ = crewData.data;
    }
  }

}
